import { TEXTURE_SLOT_NAME, MaterialUVProperties, TextureSlotConfig } from '@easytwin/runtime';

export type MaterialType = 'MeshBasicMaterial' | 'MeshStandardMaterial' | 'MeshPhysicalMaterial';

export interface TextureSlotSelect {
  label: string;
  value?: string;
  options: Array<{
    key: string;
    label: any;
  }>;
  config?: TextureSlotConfig;
}

export interface MaterialEditorConfig extends MaterialUVProperties {
  name: string;
  type: MaterialType;
  textureSlots: {
    [key in (typeof TEXTURE_SLOT_NAME)[number]]?: TextureSlotSelect;
  };
}

export const TEXTURE_SLOT_NAME_MAP = {
  map: { label: '颜色贴图', property: 'map' },
  envMap: { label: '环境贴图', property: 'envMap' },
  lightMap: { label: '光照贴图', property: 'lightMap' },
  aoMap: { label: '环境遮蔽贴图', property: 'aoMap' },
  bumpMap: { label: '凹凸贴图', property: 'bumpMap' },
  normalMap: { label: '法线贴图', property: 'normalMap' },
  displacementMap: { label: '位移贴图', property: 'displacementMap' },
  emissiveMap: { label: '自发光贴图', property: 'emissiveMap' },
  anisotropyMap: { label: '各向异性贴图', property: 'anisotropyMap' },
  clearcoatMap: { label: '清漆贴图', property: 'clearcoatMap' },
  clearcoatRoughnessMap: { label: '清漆粗糙度贴图', property: 'clearcoatRoughnessMap' },
  clearcoatNormalMap: { label: '清漆法线贴图', property: 'clearcoatNormalMap' },
  iridescenceMap: { label: '彩虹色贴图', property: 'iridescenceMap' },
  iridescenceThicknessMap: { label: '彩虹色厚度贴图', property: 'iridescenceThicknessMap' },
  specularMap: { label: '镜面贴图', property: 'specularMap' },
  specularColorMap: { label: '镜面颜色贴图', property: 'specularColorMap' },
  specularIntensityMap: { label: '镜面强度贴图', property: 'specularIntensityMap' },
  roughnessMap: { label: '粗糙度贴图', property: 'roughnessMap' },
  metalnessMap: { label: '金属度贴图', property: 'metalnessMap' },
  alphaMap: { label: '透明度贴图', property: 'alphaMap' },
  transmissionMap: { label: '透射贴图', property: 'transmissionMap' },
  thicknessMap: { label: '厚度贴图', property: 'thicknessMap' },
  sheenColorMap: { label: '光泽颜色贴图', property: 'sheenColorMap' },
  sheenRoughnessMap: { label: '光泽粗糙度贴图', property: 'sheenRoughnessMap' },
};
